<style>
.card-influencer {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  align-content: space-between;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0px 3px 6px #00000029;
  border: 0.25px solid #70707030;
  border-radius: 20px;
  cursor: pointer;
  height: 200px;
  padding: 15px;
  margin: 15px;
}

.card-top {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
}

.card-middle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
}

.card-cat {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  border-top: 1px solid #edf2f9;
  overflow: hidden;
}

.card-top .card-top-followers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
}
.card-top .card-top-followers .followers-title {
  text-align: right;
  width: 100%;
  font-size: 16px;
  /* color: #37474f; */
  color: #8b8b8b;
  font-weight: 600;
  font-family: "SofiaProLightAz";
}

.card-top .card-top-followers .followers-count {
  text-align: right;
  width: 100%;
  font-size: 24px;
  color: #37474f;
  font-family: "SofiaProBoldAz";
}
.card-top .card-top-profile {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  color: #37474f;
}

.card-top-profile .profile-full-name {
  display: flex;
  justify-content: start;
  align-items: start;
  flex-direction: column;
  width: 100%;
  margin-left: 10px;
}

.card-middle .card-middle-left {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
  font-size: 14px;
  color: #37474f;
  font-family: "SofiaProRegularAz";
  font-size: 14px;
}

.card-middle .eng-count {
  color: #3D4053;
  font-weight: 600;
  font-size: 17px;
}

.card-middle .card-middle-left .eng-title {
  width: 100%;
  color: #8b8b8b;
}

.card-middle .card-middle-right .eng-title {
  color: #8b8b8b;
}

.card-middle .card-middle-right .eng-count {
  margin: auto;
}

.card-middle .card-middle-right {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: end;
  align-items: center;
  align-content: center;
  font-size: 14px;
  color: #37474f;
  font-family: "SofiaProRegularAz";
  font-size: 14px;
}
span.profile-username {
  color: #37474f;
  font-family: "SofiaProRegularAz";
  font-size: 12px;
  text-align: left;
}
span.profile-name {
  color: #37474f;
  font-family: "SofiaProRegularAz";
  font-size: 12px;
  text-align: left;
}

.card-top img.profile-img {
  width: 70px;
  height: 70px;
  border-radius: 50px;
}

.card-cat .profile-tag {
  background-color: #fff;
  border: 1px solid #d0dee4;
  border-radius: 21px;
  color: #52707c;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  padding: 7px 15px;
  margin: 10px 3px;
  z-index: 0;
  cursor: pointer;
  font-family: "SofiaProRegularAz";
  text-align: center;
}

@media only screen and (max-width: 768px) {
  .card-top img.profile-img {
    width: 40px;
    height: 40px;
  }
  .card-influencer {
    margin: 0;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  span.profile-name {
    font-size: 8px;
  }
  span.profile-username {
    font-size: 8px;
  }
  .card-top .card-top-followers .followers-count {
    font-size: 20px;
  }
  .card-cat .profile-tag {
    font-size: 8px;
  }
}
</style>

<template>
  <div class="card-influencer" @click="redirectProfile()">
    <div class="card-top">
      <div class="card-top-profile">
        <img
          onerror="this.onerror=null;this.src='../assets/searchErorr.jpg';"
          :src="resolve_img_url(result.profile_pic_url)"
          class="profile-img"
        />
        <div class="profile-full-name">
          <span class="profile-name">{{ getFull_name() }}</span>
          <span class="profile-username">@{{ getUser_name() }}</span>
        </div>
      </div>
      <div class="card-top-followers">
        <div class="followers-title">Followers</div>
        <div class="followers-count">{{ getFollowers() }}</div>
      </div>
    </div>
    <div class="card-middle">
      <div class="card-middle-left">
        <div class="eng-count">{{ getEngagementRate() }}</div>
        <div class="eng-title">Engagement</div>
      </div>
      <div class="card-middle-right">
        <div class="eng-count">{{ getLikesPerPost() }}</div>
        <div class="eng-title">
          Likes per Post
        </div>
      </div>
    </div>
    <div class="card-cat">
      <div v-for="cat in result.categories.slice(0, 4)" class="profile-tag">
        {{ cat }}
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router.js";
import { mapState, mapActions } from "vuex";
import {
  getFormattedBigNumber,
  getFullName,
  getFormattedMaxDecimalsNumber,
} from "..//format";

export default {
  name: "Card",

  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stam: "ron",
    };
  },
  components: {},

  methods: {
    redirectProfile: function() {
      router.push({ name: "RetailersBook" });
    },
    resolve_img_url: function(path) {
      let images = path;
      return images;
    },
    replaceByDefault: function(e) {
      event.target.src = "../assets/searchErorr.jpg";
    },
    getFull_name: function() {
      return getFullName(this.result.full_name);
    },
    getUser_name: function() {
      return getFullName(this.result.username);
    },
    getLikesPerPost: function() {
      return getFormattedBigNumber(this.result.likes_per_post);
    },
    getFollowers: function() {
      return getFormattedBigNumber(this.result.followers);
    },
    getEngagementRate: function() {
      return (
        getFormattedMaxDecimalsNumber(this.result.engagement_rate, 2) + "%"
      );
    },
  },
  computed: mapState(["user"]),
};
</script>
